import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

const REASON_MAX_LENGTH = 500;

interface RejectCancelModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
}

export default function RejectCancelModal({
  open,
  loading,
  onClose,
  onConfirm,
}: RejectCancelModalProps) {
  const [reason, setReason] = useState<string>("");

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const handleConfirm = () => {
    const trimmed = reason.trim();
    onConfirm(trimmed ? trimmed : undefined);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      slotProps={{
        paper: { sx: { [compact]: { maxHeight: "94vh" } } },
      }}
    >
      <DialogTitle>ปฏิเสธคำขอยกเลิก</DialogTitle>
      <DialogContent sx={{ [compact]: { overflowY: "auto" } }}>
        <DialogContentText sx={{ mb: 2 }}>
          ระบุเหตุผลที่ปฏิเสธคำขอยกเลิก (ไม่บังคับ) สูงสุด {REASON_MAX_LENGTH} ตัวอักษร
        </DialogContentText>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="เหตุผล (ไม่บังคับ)"
          value={reason}
          disabled={loading}
          onChange={(e) => setReason(e.target.value.slice(0, REASON_MAX_LENGTH))}
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", textAlign: "right", mt: 0.5 }}
        >
          {reason.length}/{REASON_MAX_LENGTH}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose}>
          ยกเลิก
        </Button>
        <Button
          loading={loading}
          variant="contained"
          color="error"
          onClick={handleConfirm}
        >
          ยืนยันปฏิเสธ
        </Button>
      </DialogActions>
    </Dialog>
  );
}
